import { Divider } from '@mantine/core';
import { DataManagementDropShadowContainer } from '../data-management-header';
import type { BoardSetting, CreateBoardSettingPayload } from './board-settings-client.type';
import { BoardSettingsMetadata } from './board-settings-metadata';
import { BoardSettingAction } from './board-settings-reducer';
import { CreateBoardSettingsHeader } from './create-board-settings-header';

export function CreateBoardSettings({
  state,
  dispatch,
  setPageState,
  isDirty,
  boardSettings,
  createBoardSetting,
  pendingChanges,
  onPendingChange,
  hasPendingBoards,
}: {
  state: BoardSetting;
  dispatch: React.Dispatch<BoardSettingAction>;
  setPageState: (pageState: 'update' | 'create' | 'idle') => void;
  isDirty: boolean;
  boardSettings: BoardSetting[];
  createBoardSetting: (boardSetting: CreateBoardSettingPayload) => void;
  pendingChanges: Partial<CreateBoardSettingPayload>;
  onPendingChange: (changes: Partial<CreateBoardSettingPayload>) => void;
  hasPendingBoards: boolean;
}) {
  // Provide a temporary client-side id if missing to enable editing in BoardSettingsMetadata
  const stateWithTempId = state.id ? state : { ...state, id: `__tmp_${Date.now()}` };

  return (
    <DataManagementDropShadowContainer>
      <CreateBoardSettingsHeader
        state={state}
        dispatch={dispatch}
        setPageState={setPageState}
        isDirty={isDirty}
        boardSettings={boardSettings}
        createBoardSetting={createBoardSetting}
        hasPendingBoards={hasPendingBoards}
        pendingChanges={pendingChanges}
      />
      <Divider style={{ marginTop: 24, marginBottom: 24 }} />
      <BoardSettingsMetadata
        selectedBoardSetting={stateWithTempId}
        isEditing={true}
        pendingChanges={pendingChanges}
        onPendingChange={onPendingChange}
        isSaving={false}
      />
    </DataManagementDropShadowContainer>
  );
}
